import { useMutation } from '@tanstack/react-query';
import { loaders } from './admin-notifications.loaders';

export const useSendPushNotification = () => {
  return useMutation(loaders.sendPushNotification);
};
